<template>
  <div class="cr-page">
    <van-nav-bar title="客资" :border="false" />
    <div style="padding:0 16px 8px"><van-search v-model="keyword" placeholder="搜索姓名/电话" shape="round" @search="onSearch" /></div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
      <div class="dd-card cr-card" v-for="item in list" :key="item.id" @click="showDetail(item)">
        <div class="cr-top"><span class="cr-name">{{ item.name || '-' }}</span><van-tag v-if="item.grade" :type="gradeType(item.grade)" size="medium">{{ item.grade }}类</van-tag></div>
        <div class="cr-phone">{{ item.phone }}</div>
        <div class="cr-info"><span>{{ item.project }}</span><span v-if="item.area">{{ item.area }}</span></div>
      </div>
    </van-list>
    <van-action-sheet v-model="detailVisible" title="客资详情">
      <div style="padding:0 16px 20px" v-if="currentItem">
        <van-cell title="姓名" :value="currentItem.name||'-'" /><van-cell title="电话" :value="currentItem.phone" /><van-cell title="项目" :value="currentItem.project" />
        <van-cell title="地区" :value="currentItem.area||'-'" /><van-cell title="评级"><template #default><van-tag v-if="currentItem.grade" :type="gradeType(currentItem.grade)">{{ currentItem.grade }}类</van-tag><span v-else>-</span></template></van-cell>
        <van-cell title="备注" :value="currentItem.remark||'-'" />
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { getCustomerResourceList } from '@/api/customerResource'
export default {
  name: 'CustomerResource',
  data() { return { keyword:'',list:[],page:1,pageSize:20,total:0,loading:false,finished:false,detailVisible:false,currentItem:null } },
  methods: {
    onSearch() { this.page=1;this.list=[];this.finished=false;this.loading=true;this.loadMore() },
    loadMore() { var self=this;getCustomerResourceList({page:this.page,pageSize:this.pageSize,name:this.keyword||undefined,phone:this.keyword||undefined}).then(function(res){if(res.code===0){var nl=res.data.list||[];self.total=res.data.total||0;self.list=self.list.concat(nl);self.page++;if(self.list.length>=self.total)self.finished=true}else self.finished=true}).catch(function(){self.finished=true}).finally(function(){self.loading=false}) },
    showDetail(item) { this.currentItem=item;this.detailVisible=true },
    gradeType(g) { return {A:'success',B:'primary',C:'warning',D:'danger'}[g]||'default' }
  }
}
</script>

<style scoped>
.cr-page { min-height:100vh; background:#F5F6FA; }
.cr-card { padding:12px 16px; border-left:3px solid #2F88FF; }
.cr-top { display:flex;justify-content:space-between;align-items:center;margin-bottom:4px; }
.cr-name { font-size:16px;font-weight:700;color:#171A1D; }
.cr-phone { font-size:14px;color:#2F88FF;font-family:'Courier New',monospace;margin:4px 0; }
.cr-info { font-size:12px;color:#A0A4AE; span { margin-right:8px; } }
</style>
